import { useAppSelector } from 'state/hooks';
import {
  selectAnalysisStatus,
  selectODUIMode,
} from 'state/originDestinationSlices';
import { selectCurrentAnalysisId } from 'state/workflowSlice';

import { ODUIMode, PROCESS_STATUS } from 'appConstants';
import { TaskBarSkeleton } from 'features/task_bar/TaskBar';

import { ODMetricsDownload } from './ODMetricsDownload';
import { ODTaskBar } from './ODTaskBar';

import styles from './ODSidebar.module.css';

export default function ODSidebar() {
  const uiMode = useAppSelector(selectODUIMode);
  const currentId = useAppSelector(selectCurrentAnalysisId);
  const status = useAppSelector(selectAnalysisStatus);

  const open = currentId !== undefined || uiMode === ODUIMode.Create;
  const inViewMode = uiMode === ODUIMode.View;

  const sidebarClasses = [
    styles.sidebar,
    styles.sidebar_scroll,
    !open && styles.sidebar_hidden,
  ].filter(Boolean) as string[];

  return (
    <TaskBarSkeleton
      classes={sidebarClasses}
      renderSectionFiller={false}
      upper={<ODTaskBar />}
      middle={null}
      lower={
        status === PROCESS_STATUS.DONE && inViewMode && <ODMetricsDownload />
      }
      lowerClassName={styles.odLower}
      ignoreHideSidebar
    />
  );
}
